export const state = {
    drawerState: true
}

export const getters = {
    drawerState: (state) => state.drawerState
}

export const mutations = {
    toggleDrawerState(state, data) {
        state.drawerState = data
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/drawer.js